<template>
  <v-content>
    <v-container>
      <v-card>
        <v-card-title>
          <h3 class="mx-auto">
            Orders (Total: {{totalOrders}})
          </h3>
          <v-spacer></v-spacer>
          <v-text-field
              v-model="search"
              color="accent"
              label="Search Orders"
              single-line
              style="max-width: 300px"
            ></v-text-field>
            <v-select
              label="Filter Orders"
              color="accent"
              v-model="asoFilter"
              :items="filterItems"
              item-text="value"
              item-value="code"
              @change="getFilteredASOs"
              style="padding-left: 30px; max-width: 300px"
            ></v-select>
            <v-btn color="accent" class="mx-4" @click="downloadOrders">Download Orders</v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :search="search"
            :loading="loading"
            item-key="uid"
            :items="orders"
            :headers="headers"
          >
            <template v-slot:item.name="{ item }">
              <router-link :to="`/app/orders/${item.id}`">{{item.name}}</router-link>
            </template>
            <template v-slot:item.customerName="{ item }">
              {{item.customer.first_name}} {{item.customer.last_name}}
            </template>
            <template v-slot:item.createdAt="{ item }">
              {{item.createdAt | orderDateTime}}
            </template>
            <template v-slot:item.phone="{ item }">
              {{(item.customer.phone)? item.customer.phone: 'Not Available'}}
            </template>
            <template v-slot:item.aso="{ item }">
              {{(item.asoId === null)? 'Not Assigned': `${item.asoName} (${item.asoId})`}}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    <!--
        <v-snackbar v-model="success.status" top>
        {{success.message}}
        <v-btn color="success" text @click="success.status = false">
          Close
        </v-btn>
      </v-snackbar>
      <v-snackbar v-model="error.status" top>
        {{error.message}}
        <v-btn color="error" text @click="error.status = false">
          Close
        </v-btn>
      </v-snackbar>
      <v-dialog
        v-model="sureToDeleteDialog"
        persistent
      >
        <v-card>
          <v-card-title :style="{color: accentColor}" class="headline">DELETE!</v-card-title>
          <v-card-text
            :style="{color: accentColor}"
            color="accent"
          >
            Are you sure to DELETE?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" @click="sureToDeleteDialog = false">Cancel</v-btn>
            <v-btn color="accent" @click="deleteASO(asoToDelete)">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    -->
    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      orders: [],
      loading: false,
      search: '',
      asoFilter: null,
      sureToDeleteDialog: false,
      asoToDelete: true,
      success: {
        status: false,
        message: '',
      },
      error: {
        status: false,
        message: '',
      },
    };
  },
  filters: {
    orderDateTime: (value) => {
      const d = new Date(value);
      return `${String(d.getDate()).padStart(2, 0)}-${String(d.getMonth() + 1).padStart(2, 0)}-${d.getFullYear()} ${String(d.getHours()).padStart(2, 0)}:${String(d.getMinutes()).padStart(2, 0)}:${String(d.getSeconds()).padStart(2, 0)}`;
    },
  },
  methods: {
    async getOrders() {
      // Fetch ASOs here
      this.loading = true;
      try {
        const { orders } = this;
        const orderQuery = await this.firebase.firestore().collection('aso-order').orderBy('name', 'desc').get();
        // const orderQuery = [];
        orderQuery.forEach(async (item) => {
          orders.push({ uid: item.id, ...await item.data() });
        });
        // this.asos = asos;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getFilteredASOs() {
      // Filter the orders here
      let where = false;
      if (this.asoFilter === 'all') {
        this.asos = [];
        this.getOrders();
      } else {
        switch (this.asoFilter) {
          case 'nil':
            where = false;
            break;
          case 'mapped':
            where = true;
            break;
          default:
            where = false;
            break;
        }
        this.loading = true;
        this.orders = [];
        try {
          const { orders } = this;
          const ordersQuery = await this.firebase.firestore().collection('aso-order').where('aso', '==', where).get();
          ordersQuery.forEach(async (item) => {
            orders.push({ uid: item.id, ...await item.data() });
          });
          // this.asos = asos;
          this.loading = false;
        } catch (error) {
          console.log(error);
        }
      }
    },
    async downloadOrders() {
      /* eslint-disable */
      let csvData = `OrderUID, OrdDate, OrdTime, CustCode, SKUCode, OrdQty, OrderRemarks, Temp, Due Date, ASOId, Ship To, HANADOCREF\r\n`;
      const orders = [];
      const orderQuery = await this.firebase.firestore().collection('orders').get();
      for (let i = 0; i < orderQuery.docs.length; i++) {
        let order = await orderQuery.docs[i].data();
        // orders.push(order);
        for (let j = 0; j < order.line_items.length; j++) {
          let asoId = '';
          let otcCode = '';
          let item = order.line_items[j];
          if (order.aso) {
            asoId = order.asoId;
            otcCode = order.asoCustomerCode;
          }

          let date = new Date(order.created_at);
          // console.log(date);
          let orderDate = `${String(date.getDate()).padStart(2, 0)}-${String(date.getMonth()+1).padStart(2, 0)}-${date.getFullYear()}`;
          let orderTime = `${String(date.getHours()).padStart(2, 0)}:${String(date.getMinutes()).padStart(2, 0)}:${String(date.getSeconds()).padStart(2, 0)}`;
          if (item.order_uid) {
            csvData += `${item.order_uid}, ${orderDate}, ${orderTime}, ${otcCode}, ${item.sku}, ${item.quantity}, #ECOM ORD REF:${order.name},  N, ${orderDate}, ${asoId},,\r\n`;
            console.log(item.sku);
          }
          // if(item.)
        }
      }
      // console.log('here we will download the orders');
      // const blob = await res.blob();
      const aTag = document.createElement('a');
      aTag.href = window.URL.createObjectURL(new Blob([csvData],{type: 'text/csv;charset=utf-8;'}));
      aTag.setAttribute('download', 'Orders.csv');
      aTag.click();
      // this.downloadOrders = false; */
      /* eslint-enable */
    },
  },
  computed: {
    accentColor() {
      return this.$vuetify.theme.themes.light.accent;
    },
    totalOrders() {
      return this.orders.length;
    },
    filterItems() {
      return [
        {
          code: 'all',
          value: 'All',
        },
        {
          code: 'nil',
          value: 'Not Mapped To ASO',
        },
        {
          code: 'mapped',
          value: 'Mapped To ASO',
        },
      ];
    },
    headers() {
      return [
        {
          text: 'Order Id',
          value: 'name',
        },
        {
          text: 'Created At',
          value: 'createdAt',
        },
        {
          text: 'Items',
          value: 'items',
        },
        {
          text: 'Customer Name',
          value: 'customerName',
        },
        {
          text: 'Customer Email',
          value: 'customer.email',
        },
        {
          text: 'Customer Phone',
          value: 'phone',
        },
        {
          text: 'Zipcode',
          value: 'zipcode',
        },
        {
          text: 'Assigned ASO',
          value: 'aso',
        },

      ];
    },
  },
  beforeMount() {
    this.getOrders();
  },
};
</script>
